import { render, staticRenderFns } from "./ToccaVinoPayment.vue?vue&type=template&id=4f2b4e22&scoped=true&"
import script from "./ToccaVinoPayment.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoPayment.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoPayment.vue?vue&type=style&index=0&id=4f2b4e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b4e22",
  null
  
)

export default component.exports